import React, { ReactElement, FunctionComponent, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Touchable from '@sport1/react-elements/Touchable'
import Badge from '../../../BaseComponents/Badges'
import { TextColorTypes } from '../../../Theme/Fonts/FontTypes'
import { TestID } from '../../../utils/PropTypesDefinitions'

type LikesProps = {
    numberOfLikes: number
    onLike: () => void
    color?: TextColorTypes
} & TestID

const Likes: FunctionComponent<LikesProps> = ({
    numberOfLikes,
    onLike,
    color,
    testID,
}): ReactElement => {
    return (
        <Grid noExpand position="relative" width={33} testID={testID}>
            <Touchable onPress={onLike}>
                <Grid noExpand height={14} zIndex={2} position="absolute" bottom={9} left={12}>
                    <Badge backgroundColor="ORANGE">{numberOfLikes}</Badge>
                </Grid>
                <FontelloIcon name="like-active" fontSize={16} color={color} />
            </Touchable>
        </Grid>
    )
}

export default memo(Likes)
